import React from 'react';
import {FormControl, InputBase, Select, MenuItem} from "@material-ui/core";
import {createStyles, makeStyles, Theme, withStyles} from '@material-ui/core/styles';
import LanguageIcon from '@material-ui/icons/Language';
import { useTranslation } from 'react-i18next';

const BootstrapInput = withStyles((theme: Theme) =>
    createStyles({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            borderRadius: 4,
            position: 'relative',
            backgroundColor: '#575756',
            color: '#fff',
            border: '1px solid #575756',
            fontWeight: 'bold',
            padding: '10px 26px 10px 12px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
    }),
)(InputBase);

const langStyles = makeStyles((theme: Theme) =>
    createStyles({
        margin: {
            margin: theme.spacing(1),
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        },
        icon: {
            fill: '#fff',
        }
    }),
);

const Language = () => {
    const {i18n} = useTranslation();
    const classes = langStyles();

    return (
        <FormControl className={classes.margin}>
            <LanguageIcon/>
            <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                value={i18n.language}
                variant="standard"
                onChange={async (value) => {
                    await i18n.changeLanguage(value.target.value as string);
                }}
                input={<BootstrapInput/>}
                inputProps={{classes: {icon: classes.icon}}}
            >
                <MenuItem value={'ru'}>Русский</MenuItem>
                {/* <MenuItem value={'en'}>English</MenuItem> */}
            </Select>
        </FormControl>
    )
}

export default Language;